import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const HomeHeroFeaturesService = {
  async getAllFeatures() {
    let response = await $axios.get($api("home_hero_features")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : null,
      status: response?.status,
    };
  },

  async createFeature(payload: FormData) {
    try {
      const { data, status } = await $axios.post(
        $api("home_hero_features"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateFeature(id: number, payload: FormData) {
    try {
      const { data, status } = await $axios.post(
        $api("home_hero_features_id", { id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteFeature(id: number) {
    try {
      const { data, status } = await $axios.delete(
        $api("home_hero_features_id", { id }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
